import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AppConfigProvider } from './config/AppConfigContext';
import ToastProvider from './components/ToastProvider';

const MAX_RETRY_COUNTER = 3;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: MAX_RETRY_COUNTER,
    },
  },
});

const getRedirectUri = (path: string) => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }

  return path || 'http://localhost:8004';
};

const EntryPoint = (props: any) => (
  <React.StrictMode>
    <Auth0Provider
      domain={props.data.auth0Domain}
      clientId={props.data.auth0ClientId}
      cacheLocation="localstorage"
      useRefreshTokens
      useRefreshTokensFallback
      authorizationParams={{
        redirect_uri: getRedirectUri(props.data.auth0RedirectPath),
        audience: props.data.auth0Audience,
        scope: 'openid profile email offline_access',
      }}
    >
      <AppConfigProvider value={props.data}>
        <QueryClientProvider client={queryClient}>
          <ToastProvider>
            <App />
          </ToastProvider>
        </QueryClientProvider>
      </AppConfigProvider>
    </Auth0Provider>
  </React.StrictMode>
);

export default EntryPoint;
